import Navbar from "components/Navbar";
import SellerHeader from "components/dashboardSeller/SellerHeader";
import Sidebar from "components/dashboardSeller/Sidebar";
import { useEffect } from "react";
import { connect, useSelector } from "react-redux";

import { fetchDataSeller } from "store/actions/dataAction";

const DashboardSeller = ({ data, fetchDataSeller }) => {
  const { user } = useSelector((state) => state.authReducer);

  useEffect(() => {
    document.title = "Shoesnarian | Dashboard Seller";

    if (!data.productSeller)
      fetchDataSeller(`/product/seller`, "productSeller");
  }, [data, fetchDataSeller]);

  console.log(data);

  return (
    <>
      <Navbar />
      <SellerHeader user={user} />
      <Sidebar listProduct={data.productSeller} />
    </>
  );
};

const mapStateToProps = (state) => ({
  data: state.data,
});

export default connect(mapStateToProps, { fetchDataSeller })(DashboardSeller);
